import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dabc0bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "office-card bg-white border-outline-color border" }
const _hoisted_2 = { class: "office-content" }
const _hoisted_3 = { class: "office-info" }
const _hoisted_4 = { class: "office-name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "office-address" }
const _hoisted_7 = { class: "ml-auto" }

import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

type Office = {
  id: number;
  name: string;
  address: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeCard',
  props: {
  office: {
    type: Object as PropType<Office>,
    required: true
  }
},
  setup(__props) {

const props = __props;



function getSearchByOfficeRoute(officeId: number) {
  return {
    name: "SearchByOffice",
    params: {
      officeId
    }
  };
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: getSearchByOfficeRoute(__props.office.id)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.office.name), 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(FeatherIcon, {
                icon: "map-pin",
                size: "14",
                class: "mr-1 text-mild"
              }),
              _createTextVNode(),
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.office.address), 1)
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], undefined, true),
      _: 3
    }, 8, ["to"])
  ]))
}
}

})